import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component, Watch, Prop } from 'vue-property-decorator';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import ActionButton from '@/components/action_button/Index.vue';
import moment from 'moment';
import { DateTimePickerMode } from '../../helpers/entities/enums/DateTimePickerMode';
import DateMixin from '../../helpers/mixins/DateMixin';
import { SHORTDATE_FORMAT, TIME_FORMAT, DATETIME_DISPLAY_FORMAT, FULL_DATETIME_FORMAT, } from '../../helpers/constants/app';
let BaseDateTimeFieldIndex = class BaseDateTimeFieldIndex extends mixins(DateMixin) {
    constructor() {
        super(...arguments);
        this.date = this.formatDate(SHORTDATE_FORMAT);
        this.time = '00:00';
        this.toggleDatetimeDialog = false;
        this.activePicker = this.dateTimePickerModes.date;
    }
    get dateTimeISOString() {
        // Parse Date and Time using moment to avoid Date Parsing Issue
        // with other browsers
        const date = `${this.date} ${this.time}`;
        return moment(date).format();
    }
    get minDateTime() {
        const minDate = !this.minDate ? null : moment(this.minDate).add(1, 'days');
        if (!minDate || this.date > minDate.toISOString()) {
            return null;
        }
        return minDate.format('hh:mm');
    }
    get activePickerIsDate() {
        return this.activePicker === this.dateTimePickerModes.date;
    }
    get activePickerIsTime() {
        return this.activePicker === this.dateTimePickerModes.time;
    }
    // to be used in display
    get dateTimeDisplay() {
        return this.formatDate(DATETIME_DISPLAY_FORMAT, this.dateTimeISOString);
    }
    // to be used as value in form
    get dateTimeValue() {
        return this.formatDate(FULL_DATETIME_FORMAT, this.dateTimeISOString);
    }
    get dateTimePickerModes() {
        return DateTimePickerMode;
    }
    onPresetDateTimeSet(newValue) {
        this.date = this.formatDate(SHORTDATE_FORMAT, newValue);
        this.time = this.formatDate(TIME_FORMAT, newValue);
        this.setActivePicker(this.dateTimePickerModes.date);
    }
    onDateChanged() {
        this.setActivePicker(this.dateTimePickerModes.time);
    }
    showDatetimeDialog() {
        if (this.disabled) {
            return;
        }
        this.toggleDatetimeDialog = true;
    }
    hideDatetimeDialog() {
        this.toggleDatetimeDialog = false;
        this.setActivePicker(this.dateTimePickerModes.date);
        this.$emit('pickedDateTimeValue', this.dateTimeValue);
    }
    setActivePicker(picker) {
        this.activePicker = picker;
    }
};
__decorate([
    Prop({ type: String, required: true })
], BaseDateTimeFieldIndex.prototype, "presetDateTime", void 0);
__decorate([
    Prop({ type: String, required: true })
], BaseDateTimeFieldIndex.prototype, "label", void 0);
__decorate([
    Prop({ type: String, required: false })
], BaseDateTimeFieldIndex.prototype, "hint", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseDateTimeFieldIndex.prototype, "persistentHint", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], BaseDateTimeFieldIndex.prototype, "errorMessages", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseDateTimeFieldIndex.prototype, "landscape", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseDateTimeFieldIndex.prototype, "disabled", void 0);
__decorate([
    Prop({ type: String, default: null })
], BaseDateTimeFieldIndex.prototype, "minDate", void 0);
__decorate([
    Watch('presetDateTime', { immediate: true })
], BaseDateTimeFieldIndex.prototype, "onPresetDateTimeSet", null);
__decorate([
    Watch('date')
], BaseDateTimeFieldIndex.prototype, "onDateChanged", null);
BaseDateTimeFieldIndex = __decorate([
    Component({
        components: {
            BaseTextField,
            ActionButton,
        },
    })
], BaseDateTimeFieldIndex);
export default BaseDateTimeFieldIndex;
